var LINE_LENGTHS_KEY = 'line-lengths';
export function storeLineBreaksInfo(annotation) {
  var content = annotation.getContents();
  if (typeof content !== 'undefined') {
    if (content.length) {
      var parts = content.split('\n');
      if (parts.length > 1) {
        annotation.setCustomData(LINE_LENGTHS_KEY, parts.map(function (s) {
          return String(s.length);
        }).join(','));
        return;
      }
    }
    annotation.deleteCustomData(LINE_LENGTHS_KEY);
  }
}
export function restoreLineBreaks(annotation) {
  var lineLengthsString = annotation.getCustomData(LINE_LENGTHS_KEY);
  var text = annotation.getContents();
  if (text && lineLengthsString) {
    var lineLengths = lineLengthsString.split(',').map(function (s) {
      return Number(s);
    });
    var index = 0;
    var lines = lineLengths.map(function (length) {
      var line = text.substr(index, length);
      index += length;
      return line;
    });
    var dateModified = annotation.DateModified;
    annotation.setContents(lines.join('\n'));
    annotation.DateModified = dateModified;
  }
}
